const routes = [
  {
    path: 'speak',
    name: 'speak',
    component: () => import(/* webpackChunkName: "speak" */ '@/modules/speak/index.vue')
  },
  {
    path: 'speakcode',
    name: 'speakcode',
    component: () => import(/* webpackChunkName: "speakcode" */ '@/modules/speak/code.vue')
  },
];

export default routes;